module.exports = __webpack_public_path__ + "a3666b3bd4408ed4bf19fcc46efb6932.fbx";